import { createContext } from "react";

const ManualTransactionReviewContext = createContext({});

export default ManualTransactionReviewContext;
